var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.MessageList.length > 0)?_c('Inbox'):_c('div',[_c('v-card',{staticClass:"mx-auto mt-5 d-flex justify-center align-center elevation-0 rounded-xxl",attrs:{"width":"300","height":"100"}},[_c('p',{staticClass:"text-center"},[_vm._v("Not Yet Started To chat.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }